import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import http from "Utils/api2";

export const getAllNullPcategory = createAsyncThunk(
  "getAllNullPcategory",
  async (adminId, { rejectWithValue }) => {
    try {
      const response = await http.get(`/getAllNullPcategory/${adminId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: "Failed to fetch parent categories" });
    }
  }
);

export const createSubServiceCategory = createAsyncThunk(
  "createSubServiceCategory",
  async ({ adminId, formData }, { rejectWithValue }) => {
    try {
      const response = await http.post(`/createCategory/${adminId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: "Failed to create sub service" });
    }
  }
);

const createSubServicesSlice = createSlice({
  name: "createSubServices",
  initialState: {
    pCategories: [],
    loading: false,
    submitLoading: false,
    error: "",
    submitError: "",
    createResponse: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNullPcategory.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getAllNullPcategory.fulfilled, (state, action) => {
        state.loading = false;
        state.pCategories = action.payload?.data || [];
      })
      .addCase(getAllNullPcategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message || "Unable to load parent categories";
        state.pCategories = [];
      })
      .addCase(createSubServiceCategory.pending, (state) => {
        state.submitLoading = true;
        state.submitError = "";
      })
      .addCase(createSubServiceCategory.fulfilled, (state, action) => {
        state.submitLoading = false;
        state.createResponse = action.payload;
      })
      .addCase(createSubServiceCategory.rejected, (state, action) => {
        state.submitLoading = false;
        state.submitError = action?.payload?.message || "Unable to create sub service";
      });
  },
});

export default createSubServicesSlice.reducer;
